
<template>
  <router-view />
</template>
<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { isMobile } from './utils/device'

const router = useRouter()

onMounted(() => {
  if (isMobile() && router.currentRoute.value.path !== '/mobile') {
    router.replace('/mobile')
  }
})
</script>

<style scoped>
</style>